import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { analyseTheme } from "../../analyse/analyseTheme";

export const secondarySoft = "rgba(255, 153, 102, 0.15)";

export const panelCardStyles = (theme: Theme) => ({
  panelCard: {
    backgroundColor: analyseTheme.surface,
    border: `1px solid ${analyseTheme.border}`,
    borderRadius: analyseTheme.radius,
    padding: theme.spacing.unit * 3,
    display: "flex",
    flexDirection: "column" as const,
  },
  sectionTitle: {
    fontWeight: 600,
    color: analyseTheme.textPrimary,
    marginBottom: theme.spacing.unit * 2,
  },
  sectionHeader: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing.unit * 2,
  },
  sectionHeaderTitle: {
    fontWeight: 600,
    color: analyseTheme.textPrimary,
    marginBottom: 0,
  },
  sectionLink: {
    fontSize: "0.875rem",
    color: analyseTheme.textPrimary,
    paddingRight: theme.spacing.unit,
    fontWeight: 500,
    "&:hover": {
      color: theme.palette.primary.dark,
    },
  },
  panelEmpty: {
    color: analyseTheme.textSecondary,
    fontStyle: "italic" as const,
    fontSize: "0.875rem",
    marginTop: theme.spacing.unit,
  },
  activeBatchList: {
    display: "flex",
    flexDirection: "column" as const,
    gap: `${theme.spacing.unit / 2}px`,
    flex: 1,
  },
  activeBatchItem: {
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    gap: theme.spacing.unit * 2,
    textDecoration: "none",
    color: "inherit",
    padding: "6px 8px",
    margin: "0 -8px",
    borderRadius: analyseTheme.radiusXs,
    borderBottom: `1px solid ${analyseTheme.borderLight}`,
    transition: "background-color 0.2s, color 0.2s",
    "&:last-child": {
      borderBottom: "none",
    },
    "&:hover": {
      backgroundColor: secondarySoft,
      "& $activeBatchName": {
        color: theme.palette.secondary.dark,
      },
    },
  },
  activeBatchItemDisabled: {
    cursor: "default",
    "&:hover": {
      backgroundColor: "transparent",
      "& $activeBatchName": {
        color: analyseTheme.textPrimary,
      },
    },
  },
  activeBatchName: {
    flex: 1,
    minWidth: 0,
    fontWeight: 500,
    fontSize: "0.875rem",
    color: analyseTheme.textPrimary,
  },
});
